exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message[data-v-26e61bba]{max-width:250px}", ""]);

// exports
